import { FC, ReactElement } from 'react';
import PercentageMonitor from '@shared/uikit/percentage-monitor';
import { Tooltip } from 'react-tooltip';
import { Loader } from '@shared/uikit/loader';
import { formatNum } from '@app/utils/math';

interface IStatisticsIndicatorProps {
  id: string;
  title: string;
  value: string | number | ReactElement;
  percentage?: number;
  mode?: 'up' | 'down';
  conversionCurrency?: string | number;
  totalConversionCurrency?: string | number;
  tooltip?: string;
  loading?: boolean;
}

export const StatisticsIndicator: FC<IStatisticsIndicatorProps> = ({
  id,
  title,
  value,
  percentage,
  mode,
  conversionCurrency,
  totalConversionCurrency,
  tooltip,
  loading = false,
}) => {
  return (
    <div className="p-[20px] border solid rounded-[16px] border-[#959595] border-opacity-30 w-full">
      <div className="text-[#777777] flex justify-between items-center mb-[10px] relative">
        {title}
        {conversionCurrency ? (
          <div className="px-[6px] py-[4px] border border-[#959595] rounded-[16px] border-opacity-80 opacity-80 absolute right-0">
            {conversionCurrency}
          </div>
        ) : null}
        {tooltip ? (
          <>
            <span
              id={`stat-elem-${id}`}
              className="bg-[#211F24] rounded-[100%] w-[12px] h-[12px] text-[8px] text-center cursor-pointer font-bold text-[white]"
            >
              !
            </span>
            <Tooltip anchorSelect={`#stat-elem-${id}`} content={tooltip} />
          </>
        ) : null}
      </div>
      {!loading ? (
        <div className="text-[32px] gap-[10px] flex flex-col justify-between items-start relative">
          {value}
          {percentage && mode && (
            <div className="flex items-center justify-between w-full gap-[12px] text-[14px]">
              <span>
                <PercentageMonitor value={percentage} mode={mode} />
              </span>
              {totalConversionCurrency && (
                <div className="px-[6px] py-[4px] border border-[#959595] rounded-[16px] border-opacity-80 opacity-80 text-[#777777]">
                  {totalConversionCurrency}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="h-[48px]">
          <Loader size={45} loading={loading} />
        </div>
      )}
    </div>
  );
};

interface ITripleStatisticsIndicatorProps {
  id: string;
  title: string;
  conversionCurrency?: string;
  tooltip?: string;
  clients?: number;
  accounts?: number;
  hashrate?: number;
  loading?: boolean;
}

export const TripleStatisticsIndicator: FC<ITripleStatisticsIndicatorProps> = ({
  id,
  title,
  conversionCurrency,
  tooltip,
  clients,
  accounts,
  hashrate,
  loading = false,
}) => {
  return (
    <div className="p-[20px] border solid rounded-[16px] border-[#959595] border-opacity-30 w-full">
      <div className="text-[#777777] flex justify-between items-center  mb-[10px]">
        {title}
        {conversionCurrency ? (
          <div className="px-[6px] py-[4px] border border-[#959595] rounded-[16px] border-opacity-80 opacity-80">
            7.5768 USDT
          </div>
        ) : null}
        {tooltip ? (
          <>
            <span
              id={`stat-elem-${id}`}
              className="bg-[#211F24] rounded-[100%] w-[12px] h-[12px] text-[8px] text-center cursor-pointer font-bold text-[white]"
            >
              !
            </span>
            <Tooltip anchorSelect={`#stat-elem-${id}`} content={tooltip} />
          </>
        ) : null}
      </div>

      {!loading ? (
        <div className="flex justify-between">
          <div>
            <div className="text-[28px]">
              {clients !== null && clients !== undefined ? clients : '-'}
            </div>
            <div className="text-[10px] text-[#777777]">клиенты</div>
          </div>
          <div>
            <div className="text-[28px]">
              {accounts !== null && accounts !== undefined ? accounts : '-'}
            </div>
            <div className="text-[10px] text-[#777777]">аккаунты</div>
          </div>
          <div>
            <div className="text-[28px]">
              {hashrate !== null && hashrate !== undefined ? hashrate : '-'}
              {hashrate !== null && hashrate !== undefined ? (
                <span className="text-[10px] align-top">Ph</span>
              ) : null}{' '}
            </div>
            <div className="text-[10px] text-[#777777]">Хешрейт</div>
          </div>
        </div>
      ) : (
        <Loader size={30} loading={loading} />
      )}
    </div>
  );
};
